import { render } from "./CancelInterview.vue?vue&type=template&id=b3f7c4a8"
import script from "./CancelInterview.vue?vue&type=script&lang=js"
export * from "./CancelInterview.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src766051562/src/medoor-medical-records/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__